import Vue from 'vue'
import * as types from '@/store/mutation-types'

export default {
    [types.SET_USER_TOKEN]: (state, userToken) => {
        Vue.set(state, 'userToken', userToken);
    },

    [types.SET_CURRENT_USER]: (state, currentUser) => {
        Vue.set(state, 'currentUser', currentUser);
    }
}
